import { render } from "./subject_select.vue?vue&type=template&id=f7a74ee0"
import script from "./subject_select.vue?vue&type=script&lang=js"
export * from "./subject_select.vue?vue&type=script&lang=js"
script.render = render

export default script